import { Button, Card, CardContent, Grid, TextField } from '@mui/material';
import React, { useState } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { LoadingIndicator } from '../../../components/loading-indicator.component';

const styling = {
    root: { paddingRight: '15px', paddingBottom: '10px' },
    paperStyle: { padding: '0px 0px 0' },
    headingStyle: { fontWeight: 'bold' },
    buttonStyle: { width: '130px' },
    linkStyle: {
        color: '#5D6D7E',
        textDecoration: 'none',
    },
};

// Utility function to limit decimal places to 2
const limitDecimalPlaces = (value: string) => {
    if (typeof value !== 'string') {
        throw new Error('Input must be a string');
    }

    const decimalIndex = value?.indexOf('.');

    if (decimalIndex === -1) {
        // If no decimal point, return original value
        return value;
    }

    const decimalPart = value.slice(decimalIndex + 1);

    if (decimalPart.length > 2) {
        // Truncate to 2 decimal places
        return value.slice(0, decimalIndex + 1) + decimalPart.slice(0, 2);
    }

    return value; // Return as is if already valid
};

interface OfficeServiceNewPriceFields {
    disabledPricing?: boolean;
    isParentLoading?: boolean;
}

const OfficeServiceNotReadyFields = ({ disabledPricing, isParentLoading }: OfficeServiceNewPriceFields) => {
    const { control, setValue } = useFormContext();

    const sanitizeValue = (value: string, isDecimal: boolean) => {
        let sanitizedValue = value;

        if (isDecimal) {
            sanitizedValue = sanitizedValue?.replace(/[^0-9.]/g, ''); // Allow numbers and decimal points only
            sanitizedValue = limitDecimalPlaces(sanitizedValue); // Limit to 2 decimal places
        } else {
            sanitizedValue = sanitizedValue?.replace(/\D/g, ''); // Allow only numeric values
            sanitizedValue = Math.max(parseInt(sanitizedValue || '0', 10), 0).toString();
        }

        return sanitizedValue;
    };

    return (
        <Grid item lg={12} sm={12} xl={12} xs={12}>
            <Grid container spacing={2}>
                <Grid item>
                    <Controller
                        control={control}
                        name="dryRunFee"
                        render={({ field: { onChange, onBlur, value } }) => (
                            <>
                                <LoadingIndicator isLoading={isParentLoading} />
                                <TextField
                                    name="dryRunFee"
                                    label="Dry Run Fee $"
                                    value={value || ''}
                                    onChange={
                                        (e) => onChange(sanitizeValue(e.target.value, true)) // true for decimal handling
                                    }
                                    disabled={disabledPricing}
                                    onBlur={onBlur}
                                    variant="outlined"
                                    size="small"
                                    type="text"
                                />
                            </>
                        )}
                    />
                </Grid>
                <Grid item>
                    <Controller
                        control={control}
                        name="lateCancellationFee"
                        render={({ field: { onChange, onBlur, value } }) => (
                            <>
                                <LoadingIndicator isLoading={isParentLoading} />
                                <TextField
                                    name="lateCancellationFee"
                                    label="Late Cancellation Fee $"
                                    value={value || ''}
                                    onChange={
                                        (e) => onChange(sanitizeValue(e.target.value, true)) // true for decimal handling
                                    }
                                    disabled={disabledPricing}
                                    onBlur={onBlur}
                                    variant="outlined"
                                    size="small"
                                    type="text"
                                />
                            </>
                        )}
                    />
                </Grid>
                <Grid
                    item
                // lg={4} sm={4} xl={4} xs={4}
                >
                    <Controller
                        control={control}
                        name="tripCharge"
                        render={({ field: { onChange, onBlur, value } }) => (
                            <>
                                <LoadingIndicator isLoading={isParentLoading} />
                                <TextField
                                    name="tripCharge"
                                    label="Trip Charge Fee $"
                                    value={value || ''}
                                    onChange={
                                        (e) => onChange(sanitizeValue(e.target.value, true)) // true for decimal handling
                                    }
                                    disabled={disabledPricing}
                                    onBlur={onBlur}
                                    variant="outlined"
                                    size="small"
                                    type="text"
                                />
                            </>
                        )}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default OfficeServiceNotReadyFields;
